export default __webpack_public_path__ + "75196ca15c2d2f928ade805fb6e94de1.png";